
import React from "react";
import { ImageUpload } from "@/components/ui/image-upload";

interface ProfileAvatarProps {
  avatarUrl?: string;
  onImageUpload: (url: string) => void;
  uploading: boolean;
}

const ProfileAvatar: React.FC<ProfileAvatarProps> = ({
  avatarUrl,
  onImageUpload,
  uploading
}) => {
  return (
    <div className="flex flex-col items-center gap-2 sm:w-1/3">
      <div className="flex flex-col items-center">
        <ImageUpload
          value={avatarUrl}
          onChange={onImageUpload}
          size="lg"
          className="mb-2"
          disabled={uploading}
        />
        <span className="text-sm text-muted-foreground mt-2">Profile picture *</span>
      </div>
    </div>
  );
};

export default ProfileAvatar;
